// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// Attacher Swiper à window pour qu'il soit accessible dans d'autres scripts
window.Swiper = Swiper;

document.addEventListener("DOMContentLoaded", (event) => {
    //Initialisation des sliders basique avec passage en paramètre des options si besoin directement sur le conteneur avec la classe __MyfSlider
    const MyfSlider = document.getElementsByClassName('__MyfSlider');
    Array.prototype.forEach.call(MyfSlider,
      function(CurrentSlider) {
  
        let MyfSliderId = CurrentSlider.getAttribute('data-myfsliderid');
        let CurrentOptions = CurrentSlider.getAttribute('data-options');
        let MyfSliderOptions = "";
  
        let OptionsDefault = {          
          slidesPerView: 'auto',
          freeMode: true, 
          effect: 'slide',
          observeParents: true,
          observer: true,
          loop: true,
          spaceBetween: 10,
          fadeEffect: {
            crossFade: true
          },
          // Navigation arrows
          navigation: {
            nextEl: '.__MyfSlider__next--'+MyfSliderId,
            prevEl: '.__MyfSlider__prev--'+MyfSliderId,
          },
          pagination: {
            el: '.__MyfSlider-pagination--'+MyfSliderId,
          },
          autoplay: {
            delay: 3000,
          },
          on: {
            init: function (swiper) {
                updateSlideCounter(swiper, MyfSliderId);
                
                checkIfSwipeIsNeeded(CurrentSlider, MyfSliderId);
            },
            slideChange: function (swiper) {
                updateSlideCounter(swiper, MyfSliderId);
            },
          },
          breakpoints: {
              // when window width is >= 640px
              640: {
                  slidesPerView: 4,
                  effect: 'fade',
                  freeMode: false, 
              },
          }
        };   
    
        //Récupérations des options déclaré sur le conteneur du slider
        if(CurrentOptions && CurrentOptions != "") {
          CurrentOptions = CurrentOptions.replace(/'/g, '"');
          CurrentOptions = JSON.parse(CurrentOptions);
          MyfSliderOptions = {
            ...OptionsDefault,
            ...CurrentOptions
          };
        } else {
          MyfSliderOptions = OptionsDefault;
        }

        const swiper = new Swiper(CurrentSlider, MyfSliderOptions);
        // Update the slide counter on slide change
        swiper.on('slideChange', function () {
            updateSlideCounter(swiper, MyfSliderId);
        });

        // Ajouter un écouteur d'événement pour le redimensionnement de la fenêtre
        window.addEventListener('resize', () => {
          checkIfSwipeIsNeeded(CurrentSlider, MyfSliderId);
      });
  
      });  
  });
      

function checkIfSwipeIsNeeded(CurrentSlider, MyfSliderId) {
  CurrentSlider.classList.remove('no-swipe');
  const prevButton = document.querySelector('.__MyfSlider__prev--' + MyfSliderId);
  const nextButton = document.querySelector('.__MyfSlider__next--' + MyfSliderId);

  if (!prevButton || !nextButton) {
    return;
  }

  if (prevButton.classList.contains('swiper-button-lock') && nextButton.classList.contains('swiper-button-lock')) {
      // Ajouter une classe si le swipe n'est pas nécessaire
      CurrentSlider.classList.add('no-swipe');
  }
}

function updateSlideCounter(swiper, swiperId) {
  const currentSlide = swiper.realIndex + 1;
  const totalSlides = swiper.slides.length;

  const currentSlideElement = document.querySelector('.__MyfSlider__counter__current--'+swiperId);
  const totalSlidesElement = document.querySelector('.__MyfSlider__counter__total--'+swiperId);
  if (currentSlideElement) {
      currentSlideElement.textContent = currentSlide;
  }

  if (totalSlidesElement) {
      totalSlidesElement.textContent = totalSlides;
  }
}